import WestVillage1 from '../../Produk/West Village/West Village.webp'
import WestVillage2 from '../../Produk/West Village/West Village (2).webp'



const WestVillageimages =[
    WestVillage1,WestVillage2
]

export default WestVillageimages;